import makerjs, {IModel} from 'makerjs';
import Length from "../../../source/js/shared/models/Geometry/Length";
import OffsetLine from './Lines/OffsetLine';
import { renderLength } from '@/functions/lengths';
import LabelCaption from './Lines/LabelCaption';

export default class DrillHole {
	x: Length;
	y: Length;
	diameter: Length;
	edge: number;

	constructor( x: Length, y: Length, diameter: Length, edge = 0 ) {
		this.x = x;
		this.y = y;
		this.diameter = diameter;
		this.edge = edge;
	}

	getId(): string {
		return 'hole-' + this.x.millimeters + '-' + this.y.millimeters + '-' + this.edge;
	}

	getPath(): MakerJs.paths.Circle {
		const diameter = ( this.diameter.in_cm() / 2 ) + 0.001; // Add 0.001 to let machine accept this drillhole. See https://app.asana.com/0/0/1201857836504279/1202032991548094/f
		return new makerjs.paths.Circle( [this.x.in_cm(), this.y.in_cm()], diameter );
	}

	getAsModel(): IModel {
		return {
			paths: {
				[ this.getId() ]: this.getPath(),
			},
			type: 'drillhole',
		};
	}

	getOffsetLines(focusedElement = ''): OffsetLine[] {
		if(focusedElement.includes("drillHoleOffsetY")) {
			return [
				new OffsetLine(
					[ this.x.in_mm(), 0 ],
					[ this.x.in_mm(), this.y.in_mm() ],
					renderLength(this.y.in_cm())
				),
			];
		}

		if(focusedElement.includes("drillHoleOffsetX")) {
			return [
				new OffsetLine(
					[ 0, this.y.in_mm() ],
					[ this.x.in_mm(), this.y.in_mm() ],
					renderLength(this.x.in_cm())
				),
			];
		}

		return [];
	}

	getLabel( label: string ): LabelCaption {
		const radius = this.diameter.divide(2);
		return new LabelCaption( [ this.x.in_mm(), this.y.add(radius).in_mm() ], label );
	}
}
